
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class AuthorizedVouchersGrid extends Serenity.EntityGrid<AuthorizedVouchersRow, any> {
        protected getColumnsKey() { return 'Administration.AuthorizedVouchers'; }
        protected getDialogType() { return AuthorizedVouchersDialog; }
        protected getIdProperty() { return AuthorizedVouchersRow.idProperty; }
        protected getInsertPermission() { return AuthorizedVouchersRow.insertPermission; }
        protected getLocalTextPrefix() { return AuthorizedVouchersRow.localTextPrefix; }
        protected getService() { return AuthorizedVouchersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}